module.exports = __webpack_public_path__ + "static/media/logo.e21d0f2d.png";